import React from "react";
import { ContinueButton, ModalTemplate, SoundFx } from "@deliverr/ui-facility";
import { FormattedMessage } from "react-intl";
import { useSortationModal } from "sortation/components/SortationModal";
import { sortationDangerIconProps } from "sortation/components/SortationModal/sortationModalIconProps";
import { StagingScanModal } from "./StagingScanModal";

export interface StagingScanErrorModalProps {
  title: string;
  text: string;
  hideModalValue: StagingScanModal;
}

export const StagingScanErrorModal: React.FC<StagingScanErrorModalProps> = ({ title, text, hideModalValue }) => {
  const { hideModal } = useSortationModal();
  return (
    <ModalTemplate
      title={<FormattedMessage id="sortation.stagingScan.errorModalTitle" defaultMessage={title} />}
      text={<FormattedMessage id="sortation.stagingScan.errorModalText" defaultMessage={text} />}
      iconProps={sortationDangerIconProps}
      soundFx={SoundFx.ERROR_FAST}
    >
      <ContinueButton block onClick={() => hideModal(hideModalValue)} />
    </ModalTemplate>
  );
};
